module.exports = __webpack_public_path__ + "media/images/icons/content-dist-1be51497a2b76d65d37f13274f66e915.svg";